import { createApp } from 'vue'
import singleSpaVue from 'single-spa-vue'

import { handleInstance, render } from './app'

import 'src/css/app.scss'

const createLifecycles = async opts => {
  return singleSpaVue({
    createApp,
    appOptions: {
      render
    },
    handleInstance: async app => handleInstance(app, opts)
  })
}

export async function init (opts) {
  const lifecycles = await createLifecycles(opts)
  return {
    bootstrap: lifecycles.bootstrap,
    mount: lifecycles.mount,
    unmount: lifecycles.unmount
  }
}
